import { Component, OnInit } from '@angular/core';
import { RequisicaoBasica } from '../../../types/RequisicaoBasica.type';
import { WorkflowService } from '../workflow.service';
import { ConfirmationService } from 'primeng/api';
import { ToastService } from '../../../services/toast.service';
import { RequisicaoAprovacao } from '../../../types/RequisicaoAprovacao.type';
import { UsuarioContexto } from '../../../types/UsuarioContexto.type';

@Component({
  selector: 'app-painel-aprovacao-historico',
  templateUrl: './painel-aprovacao-historico.component.html',
  styleUrl: './painel-aprovacao-historico.component.css',
  providers: [ConfirmationService]
})
export class PainelAprovacaoHistoricoComponent implements OnInit{

  loading: boolean = false;
  loadingAprovacao: boolean = false;

  displayDialog: boolean = false;
  mostrarErro: boolean = false;

  // Arrays separados por contexto
  requisicoesAprovar: RequisicaoBasica[] = []; // Aba: Pendente Minha Aprovação
  minhasSolicitacoes: RequisicaoBasica[] = []; // Aba: Minhas Solicitações

  justificativa: String = "";

  requisicaoSelecionada!: RequisicaoBasica;

  // Controle de abas
  abaAtiva: number = 0;

  // Contexto do usuário
  usuarioContexto: UsuarioContexto | null = null;
  nomeUsuario: string = '';
  emailUsuario: string = '';

  // Filtros
  filtroStatus: string = '';
  filtroTipo: string = '';
  filtroBusca: string = '';

  statusOptions = [
    { label: 'Pendente', value: 'PENDENTE' },
    { label: 'Aprovado', value: 'APROVADO' },
    { label: 'Reprovado', value: 'REPROVADO' },
    { label: 'Cancelado', value: 'CANCELADO' }
  ];

  tipoOptions = [
    { label: 'Provisão Cancelamento', value: 'PROVISAO_CANCELAR' },
    { label: 'Provisão Alteração', value: 'PROVISAO_ALTERAR' }
  ];

  constructor(private workflowService: WorkflowService, private toastService: ToastService, private confirmatioService: ConfirmationService){
    // Buscar informações do usuário logado
    this.nomeUsuario = localStorage.getItem('nomeUsuario') || '';
    this.emailUsuario = localStorage.getItem('emailUsuario') || '';
  }

  get isAprovador(): boolean {
    return this.usuarioContexto?.aprovador || false;
  }

  get workflowsDoUsuario(): string[] {
    return this.usuarioContexto?.workflows || [];
  }

  ngOnInit(): void {
    this.carregarContextoUsuario();
  }

  carregarContextoUsuario() {
    this.workflowService.getUsuarioContexto().subscribe({
      next: (contexto) => {
        this.usuarioContexto = contexto;

        // Atualizar options de tipo baseado nos workflows do usuário
        if (contexto.workflows && contexto.workflows.length > 0) {
          this.tipoOptions = contexto.workflows.map(workflow => ({
            label: this.formatarNomeWorkflow(workflow),
            value: workflow
          }));
        }

        // Carregar dados baseado no contexto
        if (contexto.aprovador) {
          // Se é aprovador, carrega requisições para aprovar (aba padrão)
          this.buscarRequisicoesAprovar();
        } else {
          // Se não é aprovador, carrega minhas solicitações
          this.buscarMinhasSolicitacoes();
        }
      },
      error: (erro) => {
        console.error('Erro ao carregar contexto do usuário:', erro);
        // Se falhar, assume que não é aprovador e carrega minhas solicitações
        this.usuarioContexto = { aprovador: false, workflows: [] };
        this.buscarMinhasSolicitacoes();
      }
    });
  }

  formatarNomeWorkflow(workflow: string): string {
    // Converte "PROVISAO_CANCELAR" em "Provisão Cancelamento"
    return workflow
      .split('_')
      .map(palavra => palavra.charAt(0) + palavra.slice(1).toLowerCase())
      .join(' ')
      .replace('Provisao', 'Provisão')
      .replace('Estornar', 'Estorno');
  }
  

  buscarRequisicoesAprovar() {
    this.loading = true;

    this.workflowService.getRequisicoesAprovar().subscribe({
      next: (data) => {
        this.requisicoesAprovar = data;
      },
      error: (erro) => {
        this.toastService.erro('Erro', "Erro ao carregar requisições para aprovar: " + erro.error.message);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  buscarMinhasSolicitacoes() {
    this.loading = true;

    this.workflowService.getRequisicoes().subscribe({
      next: (data) => {
        this.minhasSolicitacoes = data;
      },
      error: (erro) => {
        this.toastService.erro('Erro', "Erro ao carregar minhas solicitações: " + erro.error.message);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  requisicoesFiltradas(): RequisicaoBasica[] {
    // Seleciona o array correto baseado na aba ativa
    let resultado: RequisicaoBasica[] = [];

    if (this.abaAtiva === 0 && this.isAprovador) {
      // Aba "Pendente Minha Aprovação"
      resultado = [...this.requisicoesAprovar];
    } else {
      // Aba "Minhas Solicitações"
      resultado = [...this.minhasSolicitacoes];
    }

    // Aplicar filtros

    // Filtrar por status
    if (this.filtroStatus) {
      resultado = resultado.filter(req => req.status === this.filtroStatus);
    }

    // Filtrar por tipo
    if (this.filtroTipo) {
      resultado = resultado.filter(req => req.entidade === this.filtroTipo);
    }

    // Filtrar por busca (identificador ou solicitante)
    if (this.filtroBusca) {
      const busca = this.filtroBusca.toLowerCase();
      resultado = resultado.filter(req =>
        req.identificador?.toLowerCase().includes(busca) ||
        req.solicitante?.toLowerCase().includes(busca)
      );
    }

    return resultado;
  }

  contarPendenteAprovacao(): number {
    return this.requisicoesAprovar.filter(f => f.status == 'PENDENTE').length;
  }

  contarMinhasSolicitacoes(): number {
    return this.minhasSolicitacoes.filter(f => f.status == 'PENDENTE').length;
  }

  onMudarAba(event: any) {
    this.abaAtiva = event.index;
    this.limparFiltros();

    // Carregar dados da aba se ainda não foram carregados
    if (this.abaAtiva === 0 && this.isAprovador && this.requisicoesAprovar.length === 0) {
      this.buscarRequisicoesAprovar();
    } else if (this.abaAtiva === 1 && this.minhasSolicitacoes.length === 0) {
      this.buscarMinhasSolicitacoes();
    }
  }

  limparFiltros() {
    this.filtroStatus = '';
    this.filtroTipo = '';
    this.filtroBusca = '';
  }

  atualizarAbaAtual() {
    if (this.abaAtiva === 0 && this.isAprovador) {
      this.buscarRequisicoesAprovar();
    } else {
      this.buscarMinhasSolicitacoes();
    }
  }

  aprovar(requisicao: RequisicaoBasica) {

    this.loadingAprovacao = true;

    this.confirmatioService.confirm({
      header: "Aprovação",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      message: "Você realmente deseja aprovar a requisição: #" + requisicao.identificador + "?",
      acceptButtonStyleClass: 'p-button-outlined text-red-500',
      rejectButtonStyleClass: 'bg-blue-500',
      icon: 'pi pi-exclamation-triangle',

      accept: () => {

        let aprovado: RequisicaoAprovacao = {
          idRequisicao: requisicao.id,
          itensAprovados: ["ALL"],
          itensReprovados: [],
          justificativaReprova: ""
        }

        this.workflowService.postAprovar(aprovado).subscribe({
          next: (data) => {

            this.toastService.sucesso("Aprovado", "" + data.mensagem);

            console.log(data);

          }, error: (error) => {

            this.toastService.erro("Erro", error.error.message);
            this.loadingAprovacao = false;

          }, complete: () => {

            this.loadingAprovacao = false;

            this.buscarRequisicoesAprovar();

          }
        })

      },

      reject: () => {
        this.loadingAprovacao = false;
      }
   })
  }

  reprovar(requisicao: RequisicaoBasica) {

    this.loadingAprovacao = true;

    this.requisicaoSelecionada = requisicao;

    this.displayDialog = true;
  }

  reprovacao(){

    if(this.justificativa.length == 0){

      this.mostrarErro = true;

      return;
    }

    let aprovado: RequisicaoAprovacao = {
          idRequisicao: this.requisicaoSelecionada.id,
          itensAprovados: [],
          itensReprovados: ["ALL"],
          justificativaReprova: this.justificativa
        }

        this.workflowService.postAprovar(aprovado).subscribe({
          next: (data) => {

            this.toastService.sucesso("Reprovado", data.mensagem);

            console.log(data);

          }, error: (error) => {

            this.toastService.erro("Erro", "" + error.error.message);
            this.loadingAprovacao = false;

          }, complete: () => {

            this.loadingAprovacao = false;

            this.displayDialog = false;
            this.mostrarErro = false;

            this.buscarRequisicoesAprovar();

          }
        })
  }

  cancelarReprovacao() {
    this.loadingAprovacao = false;
    this.displayDialog = false;
  }

  cancelarRequisicao(requisicao: RequisicaoBasica) {
    this.confirmatioService.confirm({
      header: "Cancelar Requisição",
      acceptLabel: "Sim, cancelar",
      rejectLabel: "Não",
      message: `Você realmente deseja cancelar a requisição #${requisicao?.identificador}? Esta ação não pode ser desfeita.`,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary p-button-outlined',

      accept: () => {
        this.loadingAprovacao = true;

        this.workflowService.cancelarRequisicao(requisicao!.id).subscribe({
          next: (data) => {
            this.toastService.sucesso("Sucesso", "Requisição cancelada com sucesso");
          },
          error: (error) => {
            console.log(error)
            this.toastService.erro("Erro", error.error?.message || 'Erro ao cancelar requisição');
            this.loadingAprovacao = false;
          },
          complete: () => {
            this.loadingAprovacao = false;

            this.buscarMinhasSolicitacoes();
          }
        });
      }
    });
  }

}
